import {CircularProgressBar} from "../../../progress-bar/CircularProgressBar";
import React, {useState} from "react";
import styled from "styled-components";
import {useSelector} from "react-redux";
import EditButton from "../../../buttons/EditButton";
import AdvancementModal from "../../../modal/AdvancementModal";

const Advancement = ({fromWelcomeSection}) => {

    const {advancement} = useSelector(state => state.project)
    const [isOpenEditModal, setIsOpenEditModal] = useState(false)

    const getText = () => {
        if (advancement === 0) {
            return "Votre projet n'a pas encore débuté."
        } else if (advancement >= 5 && advancement < 25) {
            return "Bravo, votre projet est bien lancé !"
        } else if (advancement >= 25 && advancement < 50) {
            return "En route ! Votre projet est avancé et le plan d'actions se poursuit."
        } else if (advancement >= 50 && advancement < 75) {
            return "Bel engagement ! De grandes étapes ont été franchies en équipe."
        } else if (advancement >= 75 && advancement <= 99) {
            return "Dernière ligne droite ! Il reste encore quelques étapes avant de finaliser votre projet."
        } else {
            return "Félicitations à toute l'équipe ! Votre projet est clôturé. Vous pouvez être fiers de vous !"
        }
    }
    return (
        <Item>
            {
                !fromWelcomeSection &&

                <EditButton
                    setUpdate={setIsOpenEditModal}
                    data={isOpenEditModal}
                />
            }
            {CircularProgressBar(advancement)}
            <div className={"flex-col ai-center gap-05"}>
                <p className={"fw-700"}> {getText()} </p>
                <p>Ce résultat clé met en évidence le ressenti de votre avancée sur ce projet !
                    Nous vous invitons à prendre en compte les grandes étapes franchies par votre équipe projet
                    (objectifs, actions, succès...). </p>
            </div>

            {isOpenEditModal &&
            <AdvancementModal
                setIsOpen={setIsOpenEditModal}
            />
            }
        </Item>
    )
}

const Item = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
width: 100%;
  .tooltip {
    align-self: flex-end;
    
  }
  .edit-btn {
    order: 3;
    align-self: flex-start;
  }

  #circular-progress-bar {
    height: 8rem;
  }

  @media (min-width: 900px) {
    flex-direction: column;
    justify-content: flex-start;
    .tooltip {
      justify-content: flex-end;
    }   
    .edit-btn {
      align-self: flex-end;
      order: 0;
    }
    width: 40%;
  }
 
`

export default Advancement